import { useTheme } from '@emotion/react';

import Accordion from '~/common/components/Accordions/Accordion';
import AccordionButton from '~/common/components/Accordions/AccordionButton';
import AccordionIcon from '~/common/components/Accordions/AccordionIcon';
import AccordionItem from '~/common/components/Accordions/AccordionItem';
import AccordionPanel from '~/common/components/Accordions/AccordionPanel';
import Box from '~/common/components/Box';
import HStack from '~/common/components/Stacks/HStack';
import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format';
import FormulaBreakdown from '~/pages/RentalIncome/RentalIncomeCalculation/ReviewBreakdown/FormulaBreakdown';
import RentalCalculationReviewBreakdown from '~/pages/RentalIncome/RentalIncomeCalculation/model/RentalCalculationReviewBreakdown';

type Rental1007Props = {
  data?: RentalCalculationReviewBreakdown;
  pitia?: number;
  formulas?: any;
  hideAccordion?: boolean;
};

const Rental1007 = ({
  formulas,
  data,
  pitia,
  hideAccordion,
}: Readonly<Rental1007Props>) => {
  const theme = useTheme();

  if (!data) {
    return null;
  }

  return (
    <Box>
      {hideAccordion && (
        <Box pl="1rem">
          <FormulaBreakdown formulas={formulas} />
        </Box>
      )}
      {!hideAccordion && (
        <Accordion defaultIndex={[0]} allowMultiple mt={8}>
          <AccordionItem
            background={theme.colors?.gray[50]}
            border={`1px solid ${theme.colors?.gray[200]}`}
          >
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                component="h3"
                fontSize="1.125rem"
                fontWeight="500"
              >
                1007/1025 Review Breakdown
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel p={4} mt="2px" background={theme.colors?.white}>
              <FormulaBreakdown formulas={formulas} />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
      <Box
        mt={8}
        backgroundColor="bgGray.100"
        padding={{ sm: '20px', md: '20px' }}
      >
        <Text fontSize="1rem" fontWeight="500">
          1007/1025:
        </Text>
        <HStack>
          <Text fontSize="0.875rem" fontWeight="500">
            Adjusted PITIA:
          </Text>
          <Text fontSize="0.875rem" fontWeight="400">
            {!!pitia && `${formatCurrency(pitia)} to `}
            {formatCurrency(data.getAdjustedPITIA())}
          </Text>
        </HStack>
        <HStack>
          <Text fontSize="0.875rem" fontWeight="500">
            Positive Net Rental Income:
          </Text>
          <Text fontSize="0.875rem" fontWeight="400">
            {formatCurrency(data.getPositiveNetRentalIncome())}
          </Text>
        </HStack>
      </Box>
    </Box>
  );
};

export default Rental1007;
